import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useColorScheme } from '@mui/material';

import { ENV, STRINGS } from '../../../constants';

const CITYSPRINT_LOGO_URL = `${ENV.CDN_BASE_URL_IMAGES}/citysprintLogo.png`;
const CITYSPRINT_DARK_LOGO_URL = `${ENV.CDN_BASE_URL_IMAGES}/citysprintDarkLogo.png`;

export const CitysprintTextLogo = () => {
  const { colorScheme } = useColorScheme();
  const logoUrl =
    colorScheme === 'dark' ? CITYSPRINT_DARK_LOGO_URL : CITYSPRINT_LOGO_URL;

  return (
    <Box
      aria-label={`${STRINGS.CITYSPRINT_SAMEDAY_LABEL} ${STRINGS.CITYSPRINT_POWERED_BY} CitySprint`}
      sx={theme => ({
        mb: 2,
        px: { xs: 1.5, sm: 2 },
        py: { xs: 1.25, sm: 1.5 },
        borderRadius: 1,
        backgroundColor: theme.vars.palette.primary.backgroundLightGray,
        border: `1px solid ${theme.vars.palette.primary.borderGray}`,
      })}
    >
      <Stack
        direction='row'
        alignItems='center'
        flexWrap='wrap'
        useFlexGap
        spacing={{ xs: 0.75, sm: 1 }}
      >
        <Typography
          variant='body2'
          component='span'
          sx={{ fontWeight: 500, color: 'text.primary', lineHeight: 1.5 }}
        >
          {STRINGS.CITYSPRINT_SAMEDAY_LABEL}
        </Typography>
        <Stack
          direction='row'
          alignItems='center'
          flexWrap='wrap'
          useFlexGap
          spacing={0.75}
        >
          <Typography
            variant='body2'
            component='span'
            color='text.secondary'
            sx={{ lineHeight: 1.5 }}
          >
            {STRINGS.CITYSPRINT_POWERED_BY}
          </Typography>
          <Box
            alt='CitySprint'
            component='img'
            decoding='async'
            loading='lazy'
            src={logoUrl}
            sx={{
              display: 'block',
              height: { xs: 18, sm: 22 },
              width: 'auto',
              maxWidth: { xs: 112, sm: 132 },
              objectFit: 'contain',
              flexShrink: 0,
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
};
